import { useEffect } from 'react';
import Navigation from '../../home/components/Navigation';
import Footer from '../../home/components/Footer';
import CTA from '../../home/components/CTA';
import { useSEO, getServiceSchema, getBreadcrumbSchema, combineSchemas } from '../../../utils/seo';

export default function SEOPage() {
  const serviceSchema = getServiceSchema(
    'SEO Services for Contractors',
    'Dominate local search results and get found by customers actively searching for your services. Proven strategies that deliver consistent organic traffic and leads.'
  );

  const breadcrumbSchema = getBreadcrumbSchema([
    { name: 'Home', url: '/' },
    { name: 'Services', url: '/services' },
    { name: 'SEO Services', url: '/services/seo' }
  ]);

  useSEO({
    title: 'SEO Services for Contractors | Local SEO & Search Engine Optimization',
    description: 'Professional SEO services for contractors. Dominate local search results and get found by customers actively searching for your services. Proven strategies that deliver consistent organic traffic and high-quality leads.',
    keywords: 'contractor SEO, local SEO for contractors, contractor search engine optimization, home service SEO, contractor Google ranking',
    canonical: '/services/seo',
    schema: combineSchemas(serviceSchema, breadcrumbSchema)
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const scrollToContact = () => {
    window.location.href = '/#contact';
  };

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      
      <section className="relative pt-32 pb-20 bg-gradient-to-br from-black via-gray-900 to-black overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-red-600/10 via-transparent to-transparent"></div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
          <div className="text-center max-w-4xl mx-auto">
            <div className="inline-flex items-center justify-center w-20 h-20 bg-red-600 rounded-2xl mb-6">
              <i className="ri-search-line text-4xl text-white"></i>
            </div>
            <h1 className="font-heading text-5xl md:text-6xl font-bold text-white mb-6">
              SEO Services for Contractors
            </h1>
            <p className="text-xl text-gray-300 mb-8">
              Dominate local search results and get found by customers actively searching for your services. Proven strategies that deliver consistent organic traffic and leads.
            </p>
            <div className="flex flex-wrap gap-4 justify-center">
              <button onClick={scrollToContact} className="inline-flex items-center px-8 py-4 bg-red-600 text-white font-semibold rounded-lg hover:bg-red-700 transition-all whitespace-nowrap cursor-pointer">
                Get Started <i className="ri-arrow-right-line ml-2"></i>
              </button>
            </div>
          </div>
        </div>
      </section>

      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {[
              { icon: 'ri-map-pin-line', title: 'Local SEO Optimization', desc: 'Rank higher in local searches and Google Maps' },
              { icon: 'ri-key-line', title: 'Keyword Research', desc: 'Target the exact terms your customers are searching' },
              { icon: 'ri-file-text-line', title: 'Content Optimization', desc: 'SEO-optimized content that ranks and converts' },
              { icon: 'ri-bar-chart-line', title: 'Performance Reports', desc: 'Monthly reports showing your ranking improvements' }
            ].map((item, index) => (
              <div key={index} className="bg-gray-50 p-8 rounded-2xl hover:shadow-xl transition-all">
                <div className="w-14 h-14 bg-red-100 rounded-xl flex items-center justify-center mb-6">
                  <i className={`${item.icon} text-2xl text-red-600`}></i>
                </div>
                <h3 className="font-heading text-xl font-bold text-black mb-3">{item.title}</h3>
                <p className="text-gray-600">{item.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CTA />
      <Footer />
    </div>
  );
}
